"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reactRouter = require("react-router");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _commonUtils = require("../../utils/common-utils");

var _actions = require("../policy/Members/actions");

var _add = _interopRequireDefault(require("./add"));

var _view = _interopRequireDefault(require("./view"));

var _edit = _interopRequireDefault(require("./edit"));

var _clone = _interopRequireDefault(require("./clone"));

var _actions2 = require("./add/actions");

var _actions3 = require("../policy/associations/actions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var PolicyRoutes = function PolicyRoutes(_ref) {
  var _match$params, _match$params2;

  var match = _ref.match,
      _ref$appManage = _ref.appManage,
      appManage = _ref$appManage === void 0 ? true : _ref$appManage,
      _ref$cachePapPolicyDa = _ref.cachePapPolicyData,
      cachePapPolicyData = _ref$cachePapPolicyDa === void 0 ? function () {} : _ref$cachePapPolicyDa,
      _ref$cacheData = _ref.cacheData,
      cacheData = _ref$cacheData === void 0 ? null : _ref$cacheData;
  var dispatch = (0, _reactRedux.useDispatch)();
  var consumerEntityId = match === null || match === void 0 ? void 0 : (_match$params = match.params) === null || _match$params === void 0 ? void 0 : _match$params.profileId;
  var appId = match === null || match === void 0 ? void 0 : (_match$params2 = match.params) === null || _match$params2 === void 0 ? void 0 : _match$params2.appId;
  var urlPaths = match.url.split("/");
  var redirectPath = urlPaths.splice(0, urlPaths.length - 1).join("/");

  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
    var _state$membersReducer;

    return state === null || state === void 0 ? void 0 : (_state$membersReducer = state.membersReducer) === null || _state$membersReducer === void 0 ? void 0 : _state$membersReducer.users;
  }),
      usersStatus = _useSelector.status,
      usersData = _useSelector.data;

  var _useSelector2 = (0, _reactRedux.useSelector)(function (state) {
    var _state$membersReducer2;

    return state === null || state === void 0 ? void 0 : (_state$membersReducer2 = state.membersReducer) === null || _state$membersReducer2 === void 0 ? void 0 : _state$membersReducer2.groups;
  }),
      groupsStatus = _useSelector2.status,
      groupsData = _useSelector2.data;

  var _useSelector3 = (0, _reactRedux.useSelector)(function (state) {
    var _state$membersReducer3;

    return state === null || state === void 0 ? void 0 : (_state$membersReducer3 = state.membersReducer) === null || _state$membersReducer3 === void 0 ? void 0 : _state$membersReducer3.tokens;
  }),
      tokensStatus = _useSelector3.status,
      tokensData = _useSelector3.data;

  var _useSelector4 = (0, _reactRedux.useSelector)(function (state) {
    var _state$membersReducer4;

    return state === null || state === void 0 ? void 0 : (_state$membersReducer4 = state.membersReducer) === null || _state$membersReducer4 === void 0 ? void 0 : _state$membersReducer4.serviceIdentities;
  }),
      serviceIdentitiesStatus = _useSelector4.status,
      serviceIdentitiesData = _useSelector4.data;

  var _useSelector5 = (0, _reactRedux.useSelector)(function (state) {
    var _state$policyReducer, _state$policyReducer$;

    return state === null || state === void 0 ? void 0 : (_state$policyReducer = state.policyReducer) === null || _state$policyReducer === void 0 ? void 0 : (_state$policyReducer$ = _state$policyReducer.add) === null || _state$policyReducer$ === void 0 ? void 0 : _state$policyReducer$.notificationMedium;
  }),
      notificationMediumStatus = _useSelector5.status,
      notificationMediumData = _useSelector5.data;

  (0, _react.useEffect)(function () {
    if ((0, _commonUtils.isApplicationProfilePolicyPath)()) {
      dispatch((0, _actions3.applicationRequest)(appId));
      dispatch((0, _actions3.environmentsRequest)(appId));
    }
  }, []);
  (0, _react.useEffect)(function () {
    if ((0, _commonUtils.isApplicationProfilePolicyPath)()) {
      dispatch((0, _actions3.scopesRequest)(consumerEntityId));
    }
  }, []);
  (0, _react.useEffect)(function () {
    if (!cacheData) {
      // dispatch(getUsersRequest());
      // dispatch(getGroupsRequest());
      dispatch((0, _actions.getServiceIdentitiesRequest)());
      dispatch((0, _actions2.approvalNotificationMediumListRequest)());
    } else {
      var _usersData = cacheData.usersData,
          _groupsData = cacheData.groupsData,
          _tokensData = cacheData.tokensData,
          _serviceIdentitiesData = cacheData.serviceIdentitiesData,
          _notificationMediumData = cacheData.notificationMediumData;
      dispatch((0, _actions.getUsersRequestSuccess)(_usersData === null || _usersData === void 0 ? void 0 : _usersData.result));
      dispatch((0, _actions.getGroupsRequestSuccess)(_groupsData === null || _groupsData === void 0 ? void 0 : _groupsData.result));
      dispatch((0, _actions.getTokensRequestSuccess)(_tokensData === null || _tokensData === void 0 ? void 0 : _tokensData.result));
      dispatch((0, _actions.getServiceIdentitiesRequestSuccess)(_serviceIdentitiesData === null || _serviceIdentitiesData === void 0 ? void 0 : _serviceIdentitiesData.result));
      dispatch((0, _actions2.approvalNotificationMediumListSuccess)(_notificationMediumData));
    }
  }, []);
  (0, _react.useEffect)(function () {
    if ((0, _commonUtils.isSuccess)(usersStatus) && (0, _commonUtils.isSuccess)(groupsStatus) && (0, _commonUtils.isSuccess)(tokensStatus) && (0, _commonUtils.isSuccess)(serviceIdentitiesStatus) && (0, _commonUtils.isSuccess)(notificationMediumStatus) && !cacheData) {
      cachePapPolicyData({
        usersData: usersData,
        groupsData: groupsData,
        tokensData: tokensData,
        serviceIdentitiesData: serviceIdentitiesData,
        notificationMediumData: notificationMediumData
      });
    }
  }, [usersStatus, groupsStatus, tokensStatus, serviceIdentitiesStatus, notificationMediumStatus, cacheData]);
  return /*#__PURE__*/_react.default.createElement(_reactRouter.Switch, null, /*#__PURE__*/_react.default.createElement(_reactRouter.Redirect, {
    exact: true,
    from: match.url,
    to: "".concat(match.url, "/add")
  }), /*#__PURE__*/_react.default.createElement(_reactRouter.Route, {
    path: "".concat(match.url, "/view/:id"),
    render: function render(props) {
      return /*#__PURE__*/_react.default.createElement(_view.default, _extends({
        consumerEntityId: consumerEntityId,
        redirectPath: redirectPath
      }, props));
    }
  }), appManage ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactRouter.Route, {
    exact: true,
    path: "".concat(match.url, "/add"),
    render: function render(props) {
      return /*#__PURE__*/_react.default.createElement(_add.default, _extends({
        consumerEntityId: consumerEntityId,
        redirectPath: redirectPath
      }, props));
    }
  }), /*#__PURE__*/_react.default.createElement(_reactRouter.Route, {
    exact: true,
    path: "".concat(match.url, "/edit/:id"),
    render: function render(props) {
      return /*#__PURE__*/_react.default.createElement(_edit.default, _extends({
        consumerEntityId: consumerEntityId,
        redirectPath: redirectPath
      }, props));
    }
  }), /*#__PURE__*/_react.default.createElement(_reactRouter.Route, {
    exact: true,
    path: "".concat(match.url, "/clone/:id"),
    render: function render(props) {
      return /*#__PURE__*/_react.default.createElement(_clone.default, _extends({
        consumerEntityId: consumerEntityId,
        redirectPath: redirectPath
      }, props));
    }
  })) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactRouter.Redirect, {
    from: "".concat(match.url, "/add"),
    to: redirectPath
  }), /*#__PURE__*/_react.default.createElement(_reactRouter.Redirect, {
    from: "".concat(match.url, "/edit/:id"),
    to: redirectPath
  }), /*#__PURE__*/_react.default.createElement(_reactRouter.Redirect, {
    from: "".concat(match.url, "/clone/:id"),
    to: redirectPath
  })));
};

PolicyRoutes.propTypes = {
  match: _propTypes.default.any,
  appManage: _propTypes.default.bool,
  cachePapPolicyData: _propTypes.default.func,
  cacheData: _propTypes.default.object
};
var _default = PolicyRoutes;
exports.default = _default;